import {get, apiRoutes} from './../../api/api';

export const REQUEST_STRUCTURE = 'REQUEST_STRUCTURE';
export const RECEIVE_STRUCTURE = 'RECEIVE_STRUCTURE';
export const NO_STRUCTURE = 'NO_STRUCTURE';
export const REQUEST_STRUCTURES = 'REQUEST_STRUCTURES';
export const RECEIVE_STRUCTURES = 'RECEIVE_STRUCTURES';
export const REQUEST_STRUCTURE_VERSIONS = 'REQUEST_STRUCTURE_VERSIONS';
export const RECEIVE_STRUCTURE_VERSIONS = 'RECEIVE_STRUCTURE_VERSIONS';

function requestStructures() {
  return {
    type: REQUEST_STRUCTURES
  };
}

function receiveStructures(data) {
  return {
    type: RECEIVE_STRUCTURES,
    items: data,
    receivedAt: Date.now()
  };
}

export function fetchStructures() {
  return dispatch => {
    dispatch(requestStructures());
    return get(apiRoutes.structures.getAll(), function (response) {
      dispatch(receiveStructures(response.data));
    });
  };
}


function requestStructure(id) {
  return {
    type: REQUEST_STRUCTURE,
    id: id
  };
}

function receiveStructure(id, data) {
  return {
    type: RECEIVE_STRUCTURE,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

function noStructure(id) {
  return {
    type: NO_STRUCTURE,
    id: id
  };
}

export function fetchStructure(id) {
  return dispatch => {
    dispatch(requestStructure(id));
    const url = apiRoutes.structures.get(id);
    return get(url, function (response) {
      dispatch(receiveStructure(id, response.data));
    }, function (err) {
      dispatch(noStructure(id));
    });
  };
}

export function fetchPublication(id, lang) {
  return dispatch => {
    dispatch(requestStructure(id));
    const url = apiRoutes.structures.getPublication(id, lang);
    return get(url, function (response) {
      dispatch(receiveStructure(id, response.data[0]));
    });
  };
}


function requestStructureVersions(id, versiontype) {
  return {
    type: REQUEST_STRUCTURE_VERSIONS,
    versiontype: versiontype,
    id: id
  };
}

function receiveStructureVersions(id, versiontype, data) {
  return {
    type: RECEIVE_STRUCTURE_VERSIONS,
    item: data,
    versiontype: versiontype,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchStructureVersions(id, versiontype) {
  return dispatch => {
    dispatch(requestStructureVersions(id));
    const url = apiRoutes.structures.getVersions(id, versiontype);
    return get(url, function (response) {
      dispatch(receiveStructureVersions(id, versiontype, response.data));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/structures/actions.js
 **/